import Accordion from "./components/accordion";
import ArticleContents from "./components/article-contens";
import ArticleScroll from "./components/article-scroll";
import BrandsSlider from "./components/brands-slider";
import CardsSlider from "./components/cards-slider";
import CurrenciesSelect from "./components/currencies-selet";
import EventsTabs from "./components/events-tabs";
import Filters from "./components/filters";
import Footer from "./components/footer";
import FooterPlaceholder from "./components/footer-placeholder";
import HeaderBurgerMenu from "./components/header-burger-menu";
import HeaderNavSublinks from "./components/header-nav-sublinks";
import HeaderSearch from "./components/header-search";
import HeroSearch from "./components/hero-search";
import ModalCookies from "./components/modal-cookies";
import ReportsSlider from "./components/reports-slider";
import SavedModal from "./components/saved-modal";
import Select from "./components/select";
import Services from "./components/services";
import StackedCards from "./components/stacked-cards";
import Tabs from "./components/tabs";
import ToUpBtn from "./components/to-up-btn";
import "./components/map";
import HeaderCart from "./components/header-cart";
import CartPage from "./components/cart-page";
import CartPageForm from "./components/validate-payment-form";
import SelectCountry from "./components/select-country";
import HeroProduct from "./components/hero-product";
import FormDownload from "./components/form-download";
import FormValidation from "./components/form-validation";
import ScrollToAnchor from "./components/scroll-to-anchor";
import ValidateCheckoutForm from "./components/validate-checkout-form";
import ValidatePaymentForm from "./components/validate-payment-form";
import UpdateLabelFile from "./components/update-label-file";
import PhoneMask from "./components/phone-mask";
import SearchFiltersTabs from "./components/search-filters-tabs";
import MailchimpPlaceholders from "./components/mailchimp-placeholders";
import RemoveCouponBtn from "./components/remove-coupon";
import BillingSubscribtionCheckbox from "./components/billing-subscribtion-checkbox";
import HeroFormStepDesc from "./components/hero-form-step-desc";
// import ContactUsModal from "./components/contact-us-modal";

document.addEventListener("DOMContentLoaded", function () {
  SelectCountry();
  HeaderNavSublinks();
  HeaderBurgerMenu();
  HeaderSearch();
  BrandsSlider();
  ModalCookies();
  ReportsSlider();
  CardsSlider();
  HeroSearch();
  Select();
  Filters();
  Accordion();
  Tabs();
  ArticleContents();
  Services();
  StackedCards();
  EventsTabs();
  ToUpBtn();
  Footer();
  ArticleScroll();
  FooterPlaceholder();
  CurrenciesSelect();
  SavedModal();
  HeaderCart();
  CartPage();
  CartPageForm();
  HeroProduct();
  // FormDownload();
  FormValidation();
  ScrollToAnchor();
  ValidateCheckoutForm();
  ValidatePaymentForm();
  // ContactUsModal();
  UpdateLabelFile();
  PhoneMask();
  SearchFiltersTabs();
  MailchimpPlaceholders();
  RemoveCouponBtn();
  BillingSubscribtionCheckbox();
  HeroFormStepDesc();
});

